import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

// Importing States from all modules
import { authState } from '@/modules/auth';
import { commonState } from '@/modules/shared';
import { timeTrackerState } from '@/modules/time_tracker';

export default createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        authState,
        commonState,
        timeTracker: timeTrackerState,
    },
    // For loading the state from a cookie
    plugins: [createPersistedState({
        storage: {
            getItem: key => Cookies.get(key),
            setItem: (key, value) => Cookies.set(key, value, { expires: 3 }),
            removeItem: key => Cookies.remove(key)
        }
    })]
});